import { ServiceBase } from "./ServiceBase";
import type {
  KitResponseDto,
  KitUpsertRequestDto,
} from "../Components/Shared/Interfaces/Kit";

export class KitsService extends ServiceBase {
  async buscar() {
    return this.get("/api/Kits/Buscar");
  }

  async buscarPor(descricao: string) {
    const qs = new URLSearchParams({ descricao });
    return this.get(`/api/Kits/BuscarPor?${qs.toString()}`);
  }

  async buscarPorId(id: number) {
    return this.get(`/api/Kits/Buscar/${id}`);
  }

  async adicionar(body: KitUpsertRequestDto) {
    return this.post("/api/Kits/Adicionar", body);
  }

  async atualizar(id: number, body: KitUpsertRequestDto) {
    return this.put(`/api/Kits/Atualizar/${id}`, body);
  }

  async deletar(id: number) {
    return this.delete(`/api/Kits/Deletar/${id}`);
  }
}

